import React from 'react'
import {NavLink } from "react-router-dom";
import NavDropdown from 'react-bootstrap/NavDropdown'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const menuLinkPath = {
  421:'',
  422:'workers',
  423:'employers',
  424:'job-orders',
  425:'deployment',
  1097:'deployment/deployed',
  1074:'deployment/for-deployment',
  426:'reports',
  1186:'reports/deployed-worker',
  427:'maintenance',
  428:'maintenance/job-categories',
}

const iconLink = {
  421:'fa-tachometer-alt',
  422:'fas fa-building',
  423:'fa-users',
  424:'fa-list-alt',
  425:'fa-globe',
  1097:'fa-circle',
  1074:'fa-circle',
  426:'fa-chart-bar',
  1186:'fa-circle',
  427:'fa-cog',
  428:'fa-circle',
}


function ChildNavLink({mid,mtitle}) {

  let menuPath = menuLinkPath[mid];
  return (
    <NavLink 
      to={menuPath}         
      className="dropdown-item"
    >
      {mtitle}
    </NavLink>
  )
}

function ThemeMenuNavlink({mid,mtitle,mchild}) {
  
  let menuPath = menuLinkPath[mid];
  let iconDisplay = iconLink[mid];
  return (
    <>     
      {mchild.length === 0 && 
        <NavLink 
            to={menuPath}      
            className="ps-4 pe-2 nav-link"
          >
            <FontAwesomeIcon className="fmenu-con" icon={iconDisplay} />            
            {mtitle}
        </NavLink> 
      }
      {mchild && mchild.length > 0 && 
      <NavDropdown title={
      <>
        <FontAwesomeIcon className="fmenu-con" icon={iconDisplay} />
        {mtitle}
        <FontAwesomeIcon className="fmenu-con-arrow" icon="fa-angle-right" />
      </>      
      
      } id={`dropdown-${mid}`}>
        {
          mchild.map((m) =>
            <ChildNavLink key={m.mlid} mid={m.mlid} mtitle={m.title}/>
          )
        }
      </NavDropdown>
      }      
    </>    
  )
}

export default ThemeMenuNavlink